import { useCart } from '../hooks/useCart';
import { formatDate } from '../helpers/formatters';
import { useTranslation } from 'react-i18next';

export default function SidebarDatepickerStatic() {
    const { timeslot } = useCart();
    const { t } = useTranslation();

    if (!timeslot) {
        return <p className="fireknife-booking-time">–</p>;
    }

    return (
        <p className="fireknife-booking-time">
            {formatDate(timeslot.startTime, t('widgetLocale'))}
        </p>
    );
}
